const changepassword = {
    en: {
        "cp.title": "Change Password",
        "cp.subtitle": "Keep your account secure with a strong, unique password.",
        "cp.currentPassword": "Current password",
        "cp.currentPlaceholder": "Enter current password",
        "cp.newPassword": "New password",
        "cp.newPlaceholder": "Enter new password",
        "cp.confirmPassword": "Confirm new password",
        "cp.confirmPlaceholder": "Re-enter new password",
        "cp.weak": "Weak",
        "cp.fair": "Fair",
        "cp.good": "Good",
        "cp.strong": "Strong",
        "cp.match": "Passwords match",
        "cp.noMatch": "Passwords do not match",
        "cp.update": "Update Password",
    },
    ru: {
        "cp.title": "Смена пароля",
        "cp.subtitle": "Защитите свой аккаунт надёжным, уникальным паролем.",
        "cp.currentPassword": "Текущий пароль",
        "cp.currentPlaceholder": "Введите текущий пароль",
        "cp.newPassword": "Новый пароль",
        "cp.newPlaceholder": "Введите новый пароль",
        "cp.confirmPassword": "Подтвердите новый пароль",
        "cp.confirmPlaceholder": "Повторно введите новый пароль",
        "cp.weak": "Слабый",
        "cp.fair": "Средний",
        "cp.good": "Хороший",
        "cp.strong": "Надёжный",
        "cp.match": "Пароли совпадают",
        "cp.noMatch": "Пароли не совпадают",
        "cp.update": "Обновить пароль",
    },
    geo: {
        "cp.title": "პაროლის შეცვლა",
        "cp.subtitle": "დაიცავით თქვენი ანგარიში ძლიერი, უნიკალური პაროლით.",
        "cp.currentPassword": "მიმდინარე პაროლი",
        "cp.currentPlaceholder": "შეიყვანეთ მიმდინარე პაროლი",
        "cp.newPassword": "ახალი პაროლი",
        "cp.newPlaceholder": "შეიყვანეთ ახალი პაროლი",
        "cp.confirmPassword": "დაადასტურეთ ახალი პაროლი",
        "cp.confirmPlaceholder": "ხელახლა შეიყვანეთ ახალი პაროლი",
        "cp.weak": "სუსტი",
        "cp.fair": "საშუალო",
        "cp.good": "კარგი",
        "cp.strong": "ძლიერი",
        "cp.match": "პაროლები ემთხვევა",
        "cp.noMatch": "პაროლები არ ემთხვევა",
        "cp.update": "პაროლის განახლება",
    },
};

export default changepassword;
